<template>
	<svg
		id="Capa_1"
		enable-background="new 0 0 512 512"
		height="15px"
		viewBox="0 0 512 512"
		width="15px"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<linearGradient id="lg1">
			<stop offset="0" stop-color="#fd3a84" />
			<stop offset="1" stop-color="#ffa68d" />
		</linearGradient>
		<linearGradient
			id="SVGID_1_"
			gradientUnits="userSpaceOnUse"
			x1="256"
			x2="256"
			xlink:href="#lg1"
			y1="180"
			y2="30"
		/>
		<linearGradient id="lg2">
			<stop offset="0" stop-color="#ffc2cc" />
			<stop offset="1" stop-color="#fff2f4" />
		</linearGradient>
		<linearGradient
			id="SVGID_2_"
			gradientUnits="userSpaceOnUse"
			x1="256"
			x2="256"
			xlink:href="#lg2"
			y1="512"
			y2="150"
		/>
		<linearGradient
			id="SVGID_3_"
			gradientUnits="userSpaceOnUse"
			x1="105"
			x2="105"
			xlink:href="#lg2"
			y1="90"
			y2="0"
		/>
		<linearGradient
			id="SVGID_4_"
			gradientUnits="userSpaceOnUse"
			x1="256"
			x2="256"
			xlink:href="#lg2"
			y1="90"
			y2="0"
		/>
		<linearGradient
			id="SVGID_5_"
			gradientUnits="userSpaceOnUse"
			x1="406"
			x2="406"
			xlink:href="#lg2"
			y1="90"
			y2="0"
		/>
		<linearGradient
			id="SVGID_6_"
			gradientUnits="userSpaceOnUse"
			x1="135.5"
			x2="135.5"
			xlink:href="#lg1"
			y1="457.096"
			y2="146.504"
		/>
		<linearGradient
			id="SVGID_7_"
			gradientUnits="userSpaceOnUse"
			x1="256"
			x2="256"
			xlink:href="#lg1"
			y1="457.096"
			y2="146.504"
		/>
		<linearGradient
			id="SVGID_8_"
			gradientUnits="userSpaceOnUse"
			x1="376"
			x2="376"
			xlink:href="#lg1"
			y1="457.096"
			y2="146.504"
		/>
		<g>
			<path
				d="m497 30h-482c-8.28 0-15 6.72-15 15v105l264 30 248-30v-105c0-8.28-6.72-15-15-15z"
				fill="url(#SVGID_1_)"
			/>
			<path
				d="m512 150v347c0 8.28-6.72 15-15 15h-482c-8.28 0-15-6.72-15-15v-347z"
				fill="url(#SVGID_2_)"
			/>
			<path
				d="m105 90c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15s15 6.716 15 15v60c0 8.284-6.716 15-15 15z"
				fill="url(#SVGID_3_)"
			/>
			<path
				d="m256 90c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15s15 6.716 15 15v60c0 8.284-6.716 15-15 15z"
				fill="url(#SVGID_4_)"
			/>
			<path
				d="m406 90c-8.284 0-15-6.716-15-15v-60c0-8.284 6.716-15 15-15s15 6.716 15 15v60c0 8.284-6.716 15-15 15z"
				fill="url(#SVGID_5_)"
			/>
			<path
				d="m166 241h-61c-8.284 0-15-6.716-15-15s6.716-15 15-15h61c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_6_)"
			/>
			<path
				d="m286 241h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_7_)"
			/>
			<path
				d="m406 241h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_8_)"
			/>
			<path
				d="m406 331h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_8_)"
			/>
			<path
				d="m286 331h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_7_)"
			/>
			<path
				d="m166 331h-61c-8.284 0-15-6.716-15-15s6.716-15 15-15h61c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_6_)"
			/>
			<path
				d="m166 421h-61c-8.284 0-15-6.716-15-15s6.716-15 15-15h61c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_6_)"
			/>
			<path
				d="m286 421h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15
			6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_7_)"
			/>
			<path
				d="m406 421h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
				fill="url(#SVGID_8_)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: "CalendarIcon",
};
</script>
